module.exports = __webpack_public_path__ + "img/arrow-item-gray.fe6ad350.svg";